// packages import
import { FC } from 'react'

// others
import { Maybe, Reference } from '../../../../generated'
import ReferenceDropdown from '../../referralSources/ReferenceDropdown'

interface ReferralTypeFilterProps {
  referenceId: string
  setReportFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const ReferralSourceFilter: FC<ReferralTypeFilterProps> = ({ setReportFilters, referenceId }) => {
  const handleReferenceChange = (value: Maybe<Reference>) => {
    setReportFilters((prev: any) => ({ ...prev, referenceId: value?.id }))
  }

  return <ReferenceDropdown customOnChange={handleReferenceChange} label="Reference" sx={{ width: '300px' }} />
}

export default ReferralSourceFilter
